"use client";

import dynamic from "next/dynamic";

/**
 * Tiny client wrapper that lazy-loads the cookie banner.
 *
 * Next 16 disallows `dynamic(..., { ssr: false })` in Server Components, so
 * the dynamic import lives here. `cookie-consent.tsx` pulls in
 * `vanilla-cookieconsent` and ~5 KB of CSS — none of which is needed before
 * First Paint, so we keep it off the critical render path.
 */
const CookieConsent = dynamic(
  () => import("./cookie-consent").then((m) => m.CookieConsent),
  { ssr: false },
);

export function CookieConsentLoader() {
  return <CookieConsent />;
}
